import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { Box, Grid, MenuItem, Stack } from "@mui/material";
import {
  StyledButton,
  StyledContainer,
  StyledDropdown,
  StyledLogo,
  StyledBadge,
  StyledAvatar,
  AvatarBox
} from "./NavBar.styles";
import Button from "../shared/Button/Button";
import API from "api";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/Provider";
import Session from "../../helpers/session";
import SharedDrawer from "components/shared/Drawer/Drawer";
import theme from "helpers/mui-theme.helper";
import { getLogo } from "./NavBarUtility";
import { useLocation } from "react-router-dom";
import { saveActiveEncounter } from "helpers/variables";

export default function NavBar() {
  const [language, setLanguage] = useState<string>(
    `${localStorage.getItem("i18nextLng")}`
  );
  const [buttonState, setButtonState] = useState({
    details: "none",
    profile: "none"
  });
  const [loggedInClient, setLoggedInClient] = useState<any>();
  const { t } = useTranslation();
  const {
    config,
    configDispatch,
    notifications,
    providerDispatch,
    member,
    settingsDispatch,
    encounterTimerDispatch,
    encounterTimer
  } = useContext(GlobalContext);
  const decodedCookie = decodeURIComponent(document.cookie);
  const location = window.location.pathname.split("/")[1];
  const routerLocation = useLocation();
  const view = window.location.pathname.split("/")[2];

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLanguage(event.target.value);
    localStorage.setItem("i18nextLng", `${event.target.value}`);
    window.location.reload();
  };
  const handleButtonState = (origin: string) => {
    if (origin === "details") {
      setButtonState({
        ...buttonState,
        details: buttonState.details === "block" ? "none" : "block"
      });
    } else if (origin === "profile") {
      setButtonState({
        ...buttonState,
        profile: buttonState.profile === "block" ? "none" : "block"
      });
    }
  };

  const handleLogout = () => {
    saveActiveEncounter(
      member,
      encounterTimerDispatch,
      settingsDispatch,
      encounterTimer?.current?.duration || 0
    );

    document.cookie =
      "life365_provider=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      "life365_session=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

    document.cookie =
      "life365_provider=; Path=/provider; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      "life365_session=; Path=/provider; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

    sessionStorage.removeItem("adminAuth");

    window.location.pathname = "/";
  };

  const coordinatorInitialsGenerator = (origin: string) => {
    const initials = Session.crackCookieUsername(origin).split(" ");
    return initials[0] !== ""
      ? `${initials[0][0].toUpperCase()}${
          initials[1] ? initials[1][0].toUpperCase() : ""
        }`
      : "";
  };

  const handlePortalNavigate = () => {
    saveActiveEncounter(member, encounterTimerDispatch, settingsDispatch, encounterTimer?.current?.duration || 0);

    if(location !== "provider"){
      window.location.pathname = "/provider";
    } else{
      window.location.pathname = "/";
    } 
  };
  
  const generateLoggedClient = () => {
    if (decodedCookie.includes("life365_session")) {
      API.kore.coordinator
        .getSingle(
          Session.crackCookieUserId("coordinator"),
          Session.crackCookieToken("coordinator")
        )
        .then((res) => {
          setLoggedInClient(res);
          providerDispatch({ type: "UPDATE_LOGGED_IN_CLIENT", payload: res });
        });
    } else if (decodedCookie.includes("life365_provider")) {
      API.kore.coordinator
        .getSingle(
          Session.crackCookieUserId("provider"),
          Session.crackCookieToken("provider")
        )
        .then((res) => {
          setLoggedInClient(res);
          providerDispatch({ type: "UPDATE_LOGGED_IN_CLIENT", payload: res });
        });
    }
  };

  useEffect(() => {
    generateLoggedClient();
    configDispatch({
      type: "COORD_IN",
      payload: decodedCookie.includes("life365_session")
    });
    configDispatch({
      type: "PROVIDER_IN",
      payload: decodedCookie.includes("life365_provider")
    });
  }, []);

  const icon = (
    <StyledAvatar>{coordinatorInitialsGenerator(location)}</StyledAvatar>
  );
  const menuItems = (
    <div>
      <Box pt={1}>
        <AvatarBox>
          <Button
            variant="primary"
            onClick={handleLogout}
            width={
              buttonState.details === "none" && buttonState.profile === "none"
                ? theme.spacing(25)
                : theme.spacing(93)
            }
          >
            {t("u-logout")}
          </Button>
        </AvatarBox>
        <AvatarBox>
        {loggedInClient?.roles?.split(",").includes("Provider") &&(
          <Button
            variant="primary"
            onClick={handlePortalNavigate}
            width={
              buttonState.details === "none" && buttonState.profile === "none"
                ? theme.spacing(25)
                : theme.spacing(93)
            }
          >
            {location === "provider" ? "Coordinator Portal": "Provider Portal"}
          </Button>
        )}
        </AvatarBox>
      </Box>
      <StyledDropdown
        value={language}
        // @ts-ignore
        onChange={handleChange}
        displayEmpty
        size={"small"}
        variant={"filled"}
        sx={{
          width:
            buttonState.details === "none" && buttonState.profile === "none"
              ? theme.spacing(25)
              : theme.spacing(90)
        }}
      >
        <MenuItem value={"en"}>English</MenuItem>
        <MenuItem value={"es"}>Español</MenuItem>
        <MenuItem value={"fr"}>Français</MenuItem>
      </StyledDropdown>
    </div>
  );
  return (
    <StyledContainer container>
      <Grid item xs={1} sm={1} />
      <Grid item xs={6} sm={6}>
        <StyledLogo src={getLogo()} />
        <br />
        {location !== "provider" &&
          location !== "admin" &&
          routerLocation.pathname !== "/" &&
          !config?.coordLogin && (
            <div style={{ marginBottom: 20 }}>
              <StyledButton to="/">Back to Login</StyledButton>
            </div>
          )
        }
        {location !== "provider" &&
          location !== "admin" &&
          config?.coordLogin && (
            <div>
              <StyledButton
                //@ts-ignore
                selectedButton={window.location.pathname === "/"}
                to="/">{t("u-members")}
              </StyledButton>
              <StyledButton
                //@ts-ignore
                selectedButton={window.location.pathname.split("/")[1] === "notifications"}
                to="/notifications">
                <StyledBadge
                  badgeContent={notifications?.itemsCount}
                  color={"warning"}
                >
                  {t("u-notifications")}
                </StyledBadge>
              </StyledButton>
            </div>
          )}
        {location === "provider" && config?.providerLogin && (
          <div>
            <StyledButton
              //@ts-ignore
              selectedButton={
                view === "coordinators" || view === "members" || view === "archived" ? true : false
              }
              to="/provider/coordinators"
            >
              {t("u-users")}
            </StyledButton>
            {/* <StyledButton to="/provider/managers">{t('u-managers')}</StyledButton> */}

            <StyledButton
              //@ts-ignore
              selectedButton={view === "reports" ? true : false}
              to="/provider/reports"
            >
              {t("u-reports")}
            </StyledButton>

            <StyledButton
              //@ts-ignore
              selectedButton={view === "configurations" ? true : false}
              to="/provider/configurations"
            >
              {t("u-configurations")}
            </StyledButton>
            <StyledButton
              //@ts-ignore
              selectedButton={view === "global" ? true : false}
              to="/provider/global/thresholds"
            >
              {'Global Thresholds'}
            </StyledButton>
            {/* {config?.orderOptions.newMember !== "none" ? ( */}
              <StyledButton
                //@ts-ignore
                selectedButton={view === "orders" ? true : false}
                to="/provider/orders"
              >
                {t("u-orders")}
              </StyledButton>
            {/* ) : (
              ""
            )} */}

            <StyledButton
              //@ts-ignore
              selectedButton={view === "readings" ? true : false}
              to="/provider/readings"
            >
              Readings
            </StyledButton>
          </div>
        )}
        {location === "admin" && view && (
          <div>
            <StyledButton
              //@ts-ignore
              selectedButton={view === "configurations" ? true : false}
              to="/admin/configurations"
            >
              {t("u-configurations")}
            </StyledButton>
            <StyledButton
              //@ts-ignore
              selectedButton={view === "ordering" ? true : false}
              to="/admin/ordering"
            >
              {'Ordering'}
            </StyledButton>
            <StyledButton
              //@ts-ignore
              selectedButton={view === "branding" ? true : false}
              to="/admin/branding"
            >
              {'Branding'}
            </StyledButton>
          </div>
        )}
      </Grid>
      <Grid item sm={1.5} lg={2.5}></Grid>
      <Grid item sm={2.5} lg={1.5}>
        <Stack spacing={2} sx={{ paddingLeft: 10 }}>
          {((location !== "login" &&
            location !== "provider" &&
            config?.coordLogin) ||
            (location === "provider" && config?.providerLogin) ||
            (location === "admin" && view)) && (
            <SharedDrawer icon={icon} menuItems={menuItems} origin={"navBar"} />
          )}
        </Stack>
      </Grid>
      <Grid item sm={1}></Grid>
    </StyledContainer>
  );
}
